import React from "react";
import { ErrorSentryFallBack } from "../../components";

export function NotFoundPage() {
  return <ErrorSentryFallBack is404={true} />;
}
